import styled from "styled-components";
import { Icon } from "components/images";
import { Link, PaginateTable } from "components";
import { getRelativeTime } from "utils";

// Fixed square so the icon column is the same size regardless of row content
const NameCard = styled.div`
  ${({ theme: { colors } }) => `
  position: relative;
  box-sizing: border-box;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 2.5rem;
  padding: 0;
  margin: 0;
  border: 1px solid ${colors("foreground", 0.1)};
  background: ${colors("shadow", 0.2)};
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:after {
    position: absolute;
    left: 0.15rem;
    bottom: 0.15rem;
    top: 0.15rem;
    content: "";
    width: 0.25rem;
  }
    &.active:after{
      background: ${colors("success")};
    }
    &.deleted:after{ 
      background: ${colors("danger")};
    }
    &.pending:after{
      background: ${colors("warning")};
    }
    &.completed:after{
      background: ${colors("highlight")};
    }
    `}
`;

const ICON = {
  conditions: "home-thermometer-outline",
  dash: "monitor-dashboard",
  trivia: "head-lightbulb-outline",
};

export const GameList = ({ queue = [], states = ["active"] }) => {
  return (
    <PaginateTable
      columns={[
        {
          title: " ",
          key: "type",
          render: (type, i, queue) => (
            <NameCard className={queue.state}>
              <Icon icon={ICON[type]} />
            </NameCard>
          ),
        },
        {
          title: "Name",
          key: "name",
          render: (name, i, queue) => (
            <Link to={`/games/${queue.type}/${queue.slug}`}>
              {name || queue.slug}
            </Link>
          ),
        },
        {
          title: "age",
          key: "created_at",
          render: (date) => {
            return getRelativeTime(date);
          },
        },
      ]}
      count={3}
      data={queue.filter((i) => states.includes(i.state))}
    />
  );
};
